<template>
  <nav class="navbar navbar-expand-lg bg-primary-4">
    <div class="navbar-nav sidebar-menu">
      <router-link class="sidebar-menu__item cursor-pointer" v-for="(item, index) in items" :key="`item-${index}`"
        :to="item.route">
        <em :class="`fas fa-${item.icon}`" />
        <span class="text-center font-14 ml-2">
          {{ item.title }}
        </span>
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'TheNavigationBar',
  computed: {
    items() {
      return [
        {
          id: 1,
          title: 'Inicio',
          icon: 'house-user',
          route: '/',
        },
        {
          id: 2,
          title: 'Solicitudes',
          icon: 'list-ul',
          route: '/',
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';

.sidebar-menu {
  height: 40px;
  margin-left: 15px;

  &__item {
    text-decoration: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-right: 20px;

    em {
      color: map-get($colors, 'primary-7');
      font-size: 12px;
    }

    span {
      color: map-get($colors, 'white');
    }

    &:not(:last-child)::after {
      content: '';
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 7.5px;
      background-color: #fff;
      opacity: 0.5;
      margin-left: 20px;
    }
  }
}
</style>
